<ul class="nav nav-pills p-3 mb-3 rounded align-items-center card flex-row">
    <li class="nav-item">
        <a href="javascript:void(0)" class="nav-link gap-6 note-link d-flex align-items-center justify-content-center px-3 px-md-3 <%= currentFilter === 'all' ? 'active' : '' %>" data-filter="all">
            <i class="ti ti-list fill-white"></i>
            <span class="d-none d-md-block fw-medium">All</span>
        </a>
    </li>
    <li class="nav-item">
        <a href="javascript:void(0)" class="nav-link gap-6 note-link d-flex align-items-center justify-content-center px-3 px-md-3 <%= currentFilter === 'active' ? 'active' : '' %>" data-filter="active">
            <i class="ti ti-briefcase fill-white"></i>
            <span class="d-none d-md-block fw-medium">Active</span>
        </a>
    </li>
    <li class="nav-item">
        <a href="javascript:void(0)" class="nav-link gap-6 note-link d-flex align-items-center justify-content-center px-3 px-md-3 <%= currentFilter === 'inactive' ? 'active' : '' %>" data-filter="inactive">
            <i class="ti ti-share fill-white"></i>
            <span class="d-none d-md-block fw-medium">Inactive</span>
        </a>
    </li>
    <li class="nav-item ms-auto">
        <a href="/template/create"
           class="btn btn-primary d-flex align-items-center px-3 gap-6" id="add-notes">
            <i class="ti ti-file-plus fs-4"></i>
            <span class="d-none d-md-block fw-medium fs-3">Create Template</span>
        </a>
    </li>
</ul>

<div class="tab-content">
    <% if ( templates && templates.length > 0 ) { %>
        <div data-type="template-list-container" class="row">
            <% templates.forEach( ( template ) => { %>
                <div class="col-md-4 mb-4">
                    <template-card></template-card>
                </div>
            <% }); %>
        </div>

    <% } else if ( totalCount === 0 ) { %>

        <div class="d-flex flex-column align-items-center justify-content-center text-center py-4 mb-4">
            <div class="mb-3">
                <iconify-icon icon="solar:file-text-line-duotone" class="text-primary" style="font-size: 3.5rem;"></iconify-icon>
            </div>
            <h3 class="mb-2">No Templates Yet</h3>
            <p class="text-muted mb-4 fs-3">Create your first template to get started.</p>
            <a href="/template/create" class="btn btn-primary btn-lg">
                <i class="ti ti-file-plus me-2"></i>
                Create Your Own Template
            </a>
        </div>

    <% } else { %>

        <div class="d-flex flex-column align-items-center justify-content-center text-center py-5">
            <div class="empty-state-icon mb-4">
                <i class="ti ti-file-x display-4 text-muted"></i>
            </div>
            <h4 class="mb-2 text-muted">No <%= currentFilter %> templates</h4>
            <p class="text-muted mb-4">There are no templates matching the selected filter.</p>
        </div>

    <% } %>
</div>

<div class="card mb-4 border border-primary border-opacity-25">
    <div class="card-body text-center pt-4 pb-4 px-4">
        <h5 class="mb-1 text-muted"><%= totalCount === 0 ? 'Or Try a Demo Template' : 'Demo Templates' %></h5>
        <p class="text-muted small mb-3">Pick one of our ready-made demos to explore features instantly.</p>

        <div class="row g-3 mt-2 justify-content-center">

            <div class="col-md-6 col-lg-3">
                <div class="card h-100 border border-opacity-25 demo-template-card" role="button" data-demo-id="text-formatting" style="cursor:pointer; transition: border-color .15s, transform .15s;">
                    <div class="card-body d-flex flex-column align-items-center text-center p-4">
                        <div class="rounded-circle bg-primary-subtle d-flex align-items-center justify-content-center mb-3" style="width:56px; height:56px;">
                            <iconify-icon icon="solar:text-field-focus-line-duotone" class="text-primary" style="font-size:1.7rem;"></iconify-icon>
                        </div>
                        <h5 class="card-title mb-2 fs-4">Text &amp; Formatting</h5>
                        <p class="card-text text-muted small mb-0">Text placeholders, transformations, date and number formatting.</p>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-3">
                <div class="card h-100 border border-opacity-25 demo-template-card" role="button" data-demo-id="image-placeholder" style="cursor:pointer; transition: border-color .15s, transform .15s;">
                    <div class="card-body d-flex flex-column align-items-center text-center p-4">
                        <div class="rounded-circle bg-success-subtle d-flex align-items-center justify-content-center mb-3" style="width:56px; height:56px;">
                            <iconify-icon icon="solar:gallery-wide-line-duotone" class="text-success" style="font-size:1.7rem;"></iconify-icon>
                        </div>
                        <h5 class="card-title mb-2 fs-4">Image Placeholders</h5>
                        <p class="card-text text-muted small mb-0">Image placeholders with fixed size, max constraints, and fit modes.</p>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-3">
                <div class="card h-100 border border-opacity-25 demo-template-card" role="button" data-demo-id="conditionals-loops" style="cursor:pointer; transition: border-color .15s, transform .15s;">
                    <div class="card-body d-flex flex-column align-items-center text-center p-4">
                        <div class="rounded-circle bg-warning-subtle d-flex align-items-center justify-content-center mb-3" style="width:56px; height:56px;">
                            <iconify-icon icon="solar:code-line-duotone" class="text-warning" style="font-size:1.7rem;"></iconify-icon>
                        </div>
                        <h5 class="card-title mb-2 fs-4">Conditionals &amp; Loops</h5>
                        <p class="card-text text-muted small mb-0">Conditional blocks (if/elseif/else) and loop iteration over arrays.</p>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-3">
                <div class="card h-100 border border-opacity-25 demo-template-card" role="button" data-demo-id="invoice" style="cursor:pointer; transition: border-color .15s, transform .15s;">
                    <div class="card-body d-flex flex-column align-items-center text-center p-4">
                        <div class="rounded-circle bg-info-subtle d-flex align-items-center justify-content-center mb-3" style="width:56px; height:56px;">
                            <iconify-icon icon="solar:bill-list-line-duotone" class="text-info" style="font-size:1.7rem;"></iconify-icon>
                        </div>
                        <h5 class="card-title mb-2 fs-4">Invoice</h5>
                        <p class="card-text text-muted small mb-0">A full invoice with a line items table and payment status condition.</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
